export default __webpack_public_path__ + "graphics/experience-1024@2x.bbdbcca9.jpg";